module.exports = __webpack_public_path__ + "img/tx-highlight.dfa6ddae.png";